import { createContext, useState, useContext, useEffect } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { useMarketToggle } from "./MarketContext";
const StockContext = createContext();

export const StockProvider = ({ children }) => {
  // const [stockData, setStockData] = useState(null);
  const [searchLoading, setSearchLoading] = useState(false);
  const [searchError, setSearchError] = useState(null);
  const [results, setResults] = useState(null);

  //   const BASE_URL = "http://localhost:8000";
  const BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const navigate = useNavigate();
  const { market, toggleMarket } = useMarketToggle();
  const isNse = market === "india";
  // const searchStock = async (searchText) => {
  //   if (!searchText.trim()) return;
  //   console.log("IsNse", isNse);

  //   try {
  //     setLoading(true);
  //     setError(null);

  //     //   if (!isNse) {

  //     //     navigate(`/searchglobal/${searchText}`);
  //     //     return;
  //     //   }
  //     if (!isNse) {
  //       try {
  //         const response = await axios.get(`${BASE_URL}/api/stockName`, {
  //           params: { keywords: searchText.trim() },
  //         });

  //         const matches = response.data.bestMatches || [];

  //         if (matches.length === 0) {
  //           setError("No global stock found for this query.");
  //           return;
  //         }

  //         // Store the results (you can show them in UI or redirect)
  //         setResults(matches);

  //         // Optional: Navigate to a global search results page
  //         navigate(`/searchglobal/${searchText}`);
  //         return;
  //       } catch (err) {
  //         console.error("Error fetching global stock results:", err.message);
  //         setError("Failed to fetch global stock results. Please try again.");
  //         return;
  //       } finally {
  //         setLoading(false);
  //       }
  //     }

  //     const response = await axios.get(`${BASE_URL}/api/stockdata`, {
  //       params: { name: searchText.trim() },
  //     });

  //     const data = response.data;

  //     // ✅ Check if valid stock data is returned
  //     if (
  //       !data ||
  //       !data.companyProfile ||
  //       !data.companyProfile.exchangeCodeNse
  //     ) {
  //       setError("Stock not found. Please try another name.");
  //       return; // ❌ stop here — no navigation
  //     }

  //     setStockData(data);

  //     // ✅ Navigate only if valid data found
  //     if (isNse) {
  //       navigate(`/search/${searchText}`);
  //     } else {
  //       console.log("Calling Global search");
  //       navigate(`/searchglobal/${searchText}`);
  //     }
  //   } catch (err) {
  //     console.error("❌ Error fetching stock data:", err);
  //     setError("Stock not found or API failed. Please try again.");
  //   } finally {
  //     setLoading(false);
  //   }
  // };
  // useEffect(() => {
  //   if (error) {
  //     const timer = setTimeout(() => setError(null), 3000);
  //     return () => clearTimeout(timer);
  //   }
  // }, [error]);

  //  const [results, setResults] = useState([]);
  // const [loading, setLoading] = useState(false);
  // const [error, setError] = useState(null);

  // const BASE_URL = process.env.REACT_APP_BASE_URL;

  /* ================= SEARCH FUNCTION ================= */
  const searchStocks = async (searchText) => {
    if (!searchText || searchText.length < 2) {
      setResults([]);
      return;
    }

    setSearchLoading(true);
    setSearchError(null);

    try {
      const res = await axios.get(`${BASE_URL}/api/search-stocks`, {
        params: { q: searchText },
      });

      setResults(res.data || []);
      return res.data;
    } catch (err) {
      console.error("Search error:", err);
      setSearchError(err.message);
      setResults([]);
    } finally {
      setSearchLoading(false);
    }
  };

  /* ================= CLEAR RESULTS ================= */
  const clearResults = () => {
    setResults([]);
  };

  return (
    <StockContext.Provider
      value={{
        results,
        searchLoading,
        searchError,
        searchStocks,
        clearResults,
      }}
    >
      {children}
    </StockContext.Provider>
  );
};

export const useStock = () => useContext(StockContext);
